<template>
  <div class="page-container">
    <el-card shadow="never">
      <div class="toolbar">
        <div class="toolbar-left">
          <el-input
            v-model="keyword"
            placeholder="搜索商品名称"
            prefix-icon="el-icon-search"
            clearable
            size="small"
            style="width: 220px; margin-right: 12px;"
            @keyup.enter.native="handleSearch"
            @clear="handleSearch"
          />
          <el-select
            v-model="shopId"
            placeholder="所属店铺"
            clearable
            filterable
            size="small"
            style="width: 180px; margin-right: 12px;"
            @change="handleSearch"
          >
            <el-option
              v-for="shop in shopList"
              :key="shop.id"
              :label="shop.name"
              :value="shop.id"
            />
          </el-select>
          <el-button type="primary" size="small" icon="el-icon-search" @click="handleSearch">搜索</el-button>
          <el-button size="small" icon="el-icon-refresh" @click="handleReset">重置</el-button>
        </div>
        <div>
          <el-button type="danger" size="small" icon="el-icon-star-on" @click="openAddDialog">新增热门商品</el-button>
        </div>
      </div>

      <el-table
        :data="tableData"
        v-loading="loading"
        border
        stripe
        style="width: 100%; margin-top: 16px;"
      >
        <el-table-column prop="id" label="ID" width="70" align="center" />
        <el-table-column label="商品图片" width="90" align="center">
          <template slot-scope="scope">
            <el-image
              v-if="getFirstImage(scope.row)"
              :src="getFirstImage(scope.row)"
              fit="cover"
              style="width: 56px; height: 56px; border-radius: 4px;"
            />
          </template>
        </el-table-column>
        <el-table-column prop="name" label="商品名称" min-width="160" show-overflow-tooltip />
        <el-table-column prop="shopName" label="所属店铺" min-width="120" show-overflow-tooltip />
        <el-table-column prop="categoryName" label="分类" width="100" align="center" />
        <el-table-column prop="dailyRent" label="日租金" width="100" align="center">
          <template slot-scope="scope">
            ¥{{ scope.row.dailyRent }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="80" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'info'" size="small">
              {{ scope.row.status === 1 ? '上架' : '下架' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="热门" width="100" align="center">
          <template slot-scope="scope">
            <el-switch
              :value="scope.row.isHot === 1"
              @change="val => toggleHot(scope.row, val)"
              active-color="#ff4d4f"
            />
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-wrapper">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :total="total"
          :page-size="pageSize"
          :current-page.sync="currentPage"
          @current-change="loadData"
        />
      </div>
    </el-card>

    <!-- 新增热门商品弹窗 -->
    <el-dialog
      title="新增热门商品"
      :visible.sync="addDialogVisible"
      width="750px"
      :close-on-click-modal="false"
    >
      <div style="margin-bottom: 12px;">
        <el-input
          v-model="addKeyword"
          placeholder="搜索商品名称"
          prefix-icon="el-icon-search"
          clearable
          size="small"
          style="width: 220px; margin-right: 12px;"
          @keyup.enter.native="loadAddCandidates"
          @clear="loadAddCandidates"
        />
        <el-button type="primary" size="small" @click="loadAddCandidates">搜索</el-button>
      </div>
      <el-table
        ref="addTable"
        :data="addCandidates"
        v-loading="addLoading"
        border
        stripe
        max-height="400"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="50" align="center" />
        <el-table-column prop="id" label="ID" width="70" align="center" />
        <el-table-column label="商品图片" width="80" align="center">
          <template slot-scope="scope">
            <el-image
              v-if="getFirstImage(scope.row)"
              :src="getFirstImage(scope.row)"
              fit="cover"
              style="width: 48px; height: 48px; border-radius: 4px;"
            />
          </template>
        </el-table-column>
        <el-table-column prop="name" label="商品名称" min-width="140" show-overflow-tooltip />
        <el-table-column prop="shopName" label="所属店铺" min-width="120" show-overflow-tooltip />
        <el-table-column prop="dailyRent" label="日租金" width="100" align="center">
          <template slot-scope="scope">
            ¥{{ scope.row.dailyRent }}
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="addSubmitting" :disabled="selectedGoods.length === 0" @click="confirmAddHot">
          确认设为热门 ({{ selectedGoods.length }})
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getGoodsList, updateGoods } from '@/api/goods'
import { getShopList } from '@/api/shop'

export default {
  name: 'HotGoods',
  data() {
    return {
      tableData: [],
      loading: false,
      keyword: '',
      shopId: null,
      shopList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      // 新增热门弹窗
      addDialogVisible: false,
      addKeyword: '',
      addCandidates: [],
      addLoading: false,
      addSubmitting: false,
      selectedGoods: []
    }
  },
  created() {
    this.loadData()
    this.loadShops()
  },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const params = {
          page: this.currentPage,
          size: this.pageSize,
          isHot: 1,
          status: -1
        }
        if (this.keyword) params.keyword = this.keyword
        if (this.shopId) params.shopId = this.shopId
        const res = await getGoodsList(params)
        if (res.data && res.data.records) {
          this.tableData = res.data.records
          this.total = res.data.total || 0
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    async loadShops() {
      try {
        const res = await getShopList({ page: 1, size: 999 })
        this.shopList = (res.data && res.data.records) || []
      } catch (e) {
        console.error(e)
      }
    },
    handleSearch() {
      this.currentPage = 1
      this.loadData()
    },
    handleReset() {
      this.keyword = ''
      this.shopId = null
      this.currentPage = 1
      this.loadData()
    },
    async toggleHot(row, val) {
      try {
        await updateGoods(row.id, { isHot: val ? 1 : 0 })
        this.$message.success(val ? '已设为热门' : '已取消热门')
        this.loadData()
      } catch (e) {
        this.$message.error('操作失败')
      }
    },
    // 新增热门弹窗
    async openAddDialog() {
      this.addDialogVisible = true
      this.addKeyword = ''
      this.selectedGoods = []
      this.loadAddCandidates()
    },
    async loadAddCandidates() {
      this.addLoading = true
      try {
        const params = {
          page: 1,
          size: 200,
          status: 1,
          isHot: 0
        }
        if (this.addKeyword) params.keyword = this.addKeyword
        params.status = -1
        const res = await getGoodsList(params)
        this.addCandidates = (res.data && res.data.records) || []
      } catch (e) {
        console.error(e)
      } finally {
        this.addLoading = false
      }
    },
    handleSelectionChange(val) {
      this.selectedGoods = val
    },
    async confirmAddHot() {
      this.addSubmitting = true
      try {
        const promises = this.selectedGoods.map(item =>
          updateGoods(item.id, { isHot: 1 })
        )
        await Promise.all(promises)
        this.$message.success(`已将 ${this.selectedGoods.length} 个商品设为热门`)
        this.addDialogVisible = false
        this.loadData()
      } catch (e) {
        this.$message.error('操作失败')
      } finally {
        this.addSubmitting = false
      }
    },
    getFirstImage(row) {
      if (!row) return ''
      let images = row.images || row.coverImage || row.image
      if (!images) return ''
      try {
        const arr = JSON.parse(images)
        return Array.isArray(arr) && arr.length > 0 ? arr[0] : ''
      } catch {
        if (images.includes(',')) {
          return images.split(',')[0] || ''
        }
        return images
      }
    }
  }
}
</script>

<style scoped>
.page-container {
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}

.toolbar-left {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.pagination-wrapper {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
}
</style>
